import React, { useEffect, useState } from 'react'
import classnames      from 'classnames'
import SelectComponent from 'pu-react/components/SelectComponent';

const options = [
  { value: 'FR4/Leaded HASL', text: 'FR4 Tg135 / Leaded HASL' },
  { value: 'FR4TG180/ENIG', text: 'FR4 Tg180 / ENIG' },
  { value: 'FR4TG180/Lead Free HASL', text: 'FR4 Tg180 / Lead Free HASL' },
  { value: 'FR4TG180/Immersion Silver', text: 'FR4 Tg180 / Immersion Silver' },
  { value: 'FR4TG180/Bare Copper', text: 'FR4 Tg180 / Bare Copper' },
  { value: 'FR4TG180/OSP', text: 'FR4 Tg180 / OSP' },
];

const tooltip = null

const MaterialTypeAndFinishPlating = (props) => {
  const name = 'material_type_finish_plating';
  const {parameters} = props
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const value = parameters.get ? parameters.get(name) : parameters[name];
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={tooltip}
      selected={value}
      groupName={props.groupName}
      className={classnames('material-type', props.className)} />
  )
};

MaterialTypeAndFinishPlating.defaultProps = {
  options,
  label   : 'Material Type / Finish Plating',
  required: true,
}
export default MaterialTypeAndFinishPlating;
